















import { Component, Prop } from 'vue-property-decorator'
import { BaseInput, ICampoTemplate } from './base/BaseInput'

@Component({
  name: 'InputSelect'
})
export default class InputSelect extends BaseInput {
  @Prop({ required: true })
  campo!: ICampoTemplate
}
